/* 
 *  Copyright (c) Intel Corporation.  All Rights Reserved.
 *
 *  Primary entry point for transmitting error/rule mismatch data to endpoints
 */
/*--!!!!!ATTENTION!!!!!-----DO NOT DELETE code inside Webpack Macros,it will be used in Analytics SDK for Web */

// #IFDEF WebPack
 
import { ModuleManager, globalEngine} from "./Init";
import { logNormal , logInformation , logWarning , logError, logDebug, logConsole , logRawTrack , logTransports , logAutomationError} from "./bootstrap_web_ext";
import { dataManipulator , isoDateToDate, findObjectSize} from "./common";

// #ENDIF WebPack
function CreateAnalyticsErrorTransmitter() 
{

    function ErrorTransmitter() { 
        this.setup();
    };

    ErrorTransmitter.prototype = ModuleManager.create("transmitter_template");

    ErrorTransmitter.prototype.profileName = "profile_analytics_automation_mosaic_100p";
    ErrorTransmitter.prototype.messageName = "analytics_event_error_occurrred";
    ErrorTransmitter.prototype.setup = function ()
    {
        if(!this.emitter)
        {
            this.emitter = this.retrieveEmitter(this.profileName);
        }
    };
    ErrorTransmitter.prototype._generate = function (messageName, errorMessage) 
    {
        var outbound = 
        {
            "hit.uniqueid": "analytics_event_error_occurrred",
            "event.category": "Analytics.Event.Error",
            "hit.trigger":messageName,
            "event.action": "Analytics.Event.Rule.Failed"
        };

        if (findObjectSize(errorMessage["type"]["ruleMismatch"])) 
        {
            outbound["hit.category.1"] = "ruleMismatch";
             outbound["event.label"] = JSON.stringify(errorMessage);
 
        } else if (findObjectSize(errorMessage["type"]["ruleError"])) 
        {
            outbound["hit.category.1"] = "ruleError";          
            outbound["event.label"] = JSON.stringify(errorMessage);

        } else if (errorMessage["type"]["rejected"]) 
        {
            outbound["hit.category.1"] = "rejected";
            outbound["event.label"] = JSON.stringify(errorMessage);;
        }

        var timeNow = new Date();
        outbound["__record.created"] = timeNow.toISOString();
        outbound["Tracker.Type"] = "event";

        return outbound;
    };
    ErrorTransmitter.prototype.transmit = function (messageName, message, errorMessage) 
    {
        logDebug("CreateAnalyticsErrorlogTransport.transmit message=" + JSON.stringify(errorMessage) + ", profileNames=" + JSON.stringify(this.profileName));

            // event-level throttle
            if (this._isEventThrottled(this.messageName)) 
            {
                logDebug("Event " + this.messageName + " was event-level throttled");
                return;
            }

            try {

                // profile-level throttle
                if (this._isProfileThrottled(this.messageName, this.profileName))
                {
                    logDebug("Event " + this.messageName + " was profile-level throttled by '" + this.profileName + "'");
                    return;
                }

                if (!this.emitter) 
                {
                    // we're in serious trouble here!
                    logError("Failed to locate an emitter for '" + this.profileName + "'; aborting send");
                    return;
                }

                var outbound = this._generate(messageName,errorMessage);

                // lowercase all
                var mappings = ModuleManager.getSingleton("mappings");
                outbound = mappings.toLowerCase(outbound, true, false);

                //apply attribute rules
                outbound = this._applyAttributeRules(outbound, this.messageName, this.profileName);;

                //add event day index
                var rules = ModuleManager.getSingleton("rules");
                var eventDayIndex = rules.getDailyMaxTableCounter(this.profileName);
                outbound['__event.day.index'] = eventDayIndex;

                //add throttle
                outbound['__throttle_user_multiplier'] = this.emitter.throttleMultiplier ? this.emitter.throttleMultiplier : 1;

                // Add default elements (UserID, contentVersion, etc)
                dataManipulator.mergeAndLowerDictionary(outbound, engine.getDefaultDictionary());

                //add dataset names
                this.addDataSetNames(outbound, this.emitter, null);

                // Add queue time
                var now_time = new Date();
                var timeStamp = unescape(outbound["__record.created"]);
                timeStamp = timeStamp.split(" ").join('T');

                var create_time = isoDateToDate(timeStamp);
                if (now_time && create_time) 
                {
                    var queue_time_milliseconds = (now_time - create_time);
                    outbound["__queue.time.milliseconds"] = String(queue_time_milliseconds);
                }

                logDebug("ready to send " + JSON.stringify(outbound));
                var result = this.emitter.send(outbound);

                //Log error message
                logAutomationError(messageName, JSON.stringify(message), JSON.stringify(errorMessage));

                logDebug('ProfileName:' + this.profileName + '. Result: ' + result);
                logDebug("******************************* done");

            }
            catch (e) 
            {
                logError("Failed to send mesage to '" + this.profileName + "': exception is '" + e.message + "'");
            }

        };

    var error_transmitter_obj = new ErrorTransmitter();
    return error_transmitter_obj;
};

// register with the factory function with ModuleManager
ModuleManager.registerFactory("error_transmitter", CreateAnalyticsErrorTransmitter);
//export {CreateAnalyticsErrorTransmitter};
//globalEngine.FactoryMap["error_transmitter"] =  CreateAnalyticsErrorTransmitter;
